import React, { useContext } from 'react';
import { Alert } from '@thd-olt-component-react/core-ui';
import { NotificationsContext } from './NotificationsProvider';

export const Notification = () => {

  const { alertConfig, isOpen } = useContext(NotificationsContext);

  return isOpen ? (
    <div className="p2p-notification-wrapper">
      <Alert type={alertConfig.type}>
        {alertConfig.message}
      </Alert>
    </div>
  ) : null;

};